import { useMutation } from "@apollo/client";

import { ProtocolUpdateProtocolVisitInput } from "~/__generated__";

import { ProtocolEditRoute_VisitUpdateDocument } from "../mutations.generated";
import { PROTOCOL_GET_BY_ID } from "./useProtocolEditRoute_GetById";

export default function useProtocolVisitUpdate(protocolId: string) {
    const [updateVisitMutation, { loading, error }] = useMutation(ProtocolEditRoute_VisitUpdateDocument, {
        refetchQueries: [{ query: PROTOCOL_GET_BY_ID, variables: { protocolId } }],
        awaitRefetchQueries: true,
    });

    return {
        updateVisit: (input: ProtocolUpdateProtocolVisitInput) =>
            updateVisitMutation({
                variables: { input },
            }),
        loading,
        error,
    };
}
